<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="个人指标"> </pageTitle>
    <basicList ref="table" :config="basicListconfig" @search="searchEvent">
      <template v-slot:otherOperations>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openAddUserDialog">添加员工</el-button>
      </template>
      <template v-slot:additionalFeatures>
        <div class="table">
          <el-table
            :data="userColumns"
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            style="width: 100%"
            row-key="user_id"
            resizable
            border
            :show-overflow-tooltip="true"
            :height="basicListconfig.height || 'calc(100vh - 350px)'"
            @sort-change="sortChange"
          >
            <el-table-column width="180" prop="name" fixed="left" label="员工姓名" />
            <el-table-column width="120" label="销售额">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.turnover_trade"
                  placeholder="指标"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column width="120" label="销售额占比">
              <template slot-scope="scope">
                <div style="display: flex;">
                  <el-input
                    size="small"
                    v-model="scope.row.turnover_ratio"
                    placeholder="占比"
                  ></el-input>
                  <span style="margin-top: 5px; margin-left: 5px;">%</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="120" label="订单数">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.order_trade"
                  placeholder="指标"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column width="120" label="订单数占比">
              <template slot-scope="scope">
                <div style="display: flex;">
                  <el-input
                    size="small"
                    v-model="scope.row.order_ratio"
                    placeholder="占比"
                  ></el-input>
                  <span style="margin-top: 5px; margin-left: 5px;">%</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="120" label="毛利">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.profit_trade"
                  placeholder="指标"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column width="120" label="毛利占比">
              <template slot-scope="scope">
                <div style="display: flex;">
                  <el-input
                    size="small"
                    v-model="scope.row.profit_ratio"
                    placeholder="占比"
                  ></el-input>
                  <span style="margin-top: 5px; margin-left: 5px;">%</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="120" label="动销数">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.sales_trade"
                  placeholder="指标"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column width="120" label="动销数占比">
              <template slot-scope="scope">
                <div style="display: flex;">
                  <el-input
                    size="small"
                    v-model="scope.row.sales_ratio"
                    placeholder="占比"
                  ></el-input>
                  <span style="margin-top: 5px; margin-left: 5px;">%</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="120" label="盘库数">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.stock_check_trade"
                  placeholder="指标"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column width="120" label="盘库数占比">
              <template slot-scope="scope">
                <div style="display: flex;">
                  <el-input
                    size="small"
                    v-model="scope.row.stock_check_ratio"
                    placeholder="占比"
                  ></el-input>
                  <span style="margin-top: 5px; margin-left: 5px;">%</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="200" label="群聊 ID">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.room_id"
                  size="small"
                  placeholder="请选择群聊 ID"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in roomIdOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span style="float: left; max-width: 150px; overflow: hidden; text-overflow: ellipsis;">{{ item.label.substring(0, item.label.lastIndexOf(' ')) }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px;">{{ item.value }}</span>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column fixed="right" width="100" label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="editUserMetric(scope.row.user_id)"
                >
                  更新
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="table_footer" v-if="basicListconfig.isPage">
            <p class="table_footer_total">
              共{{ basicListconfig.total }}项数据
            </p>
            <el-pagination
              background
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :page-sizes="[10, 50, 100, 500]"
              :current-page.sync="basicListconfig.searchParameters.page"
              :page-size="basicListconfig.searchParameters.limit"
              layout="sizes,prev, pager, next"
              :total="basicListconfig.total"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </basicList>

    <!-- 添加员工参与指标弹窗 -->
    <el-dialog title="添加员工" :visible.sync="addUserDialogVisible" width="450px" :close-on-click-modal="false">
      <el-form label-width="80px">
        <el-form-item label="添加员工">
          <el-select v-model="selectedAddUser" filterable multiple placeholder="请选择要添加的员工" style="width:100%">
            <el-option
              v-for="user in availableAddUsers"
              :key="user.id"
              :label="user.label"
              :value="user.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addUserDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAddUser" :disabled="!selectedAddUser || selectedAddUser.length === 0" :loading="addUserLoading">确定添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const defaultParameters = {
    page: 1,
    limit: 10
  };
import { getPersonalMetricList, getshoplist, personalMetricUp, getRoomIdList, userGetlist } from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
import { mapGetters } from "vuex";
export default {
  name: "personalMetric",
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopId: null,
      showColumn:true,
      // 列表组件参数
      basicListconfig: {
        table: true,
        loading: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
            change: (val) => {
              console.log('门店下拉框变化，值:', val);
              this.handleShopChange(val);
            },
          },
          {
            label: "员工",
            type: "select",
            options: [],
            key: "user_id",
            value: "",
          },
        ],
        data: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      storeList: [],
      allUsers: [], // 存储所有有指标的员工数据
      allEmployees: [], // 存储所有员工数据（用于添加员工下拉）
      tradeUserIds: [], // 已有指标的员工ID集合
      addUserDialogVisible: false,
      selectedAddUser: [],
      addUserLoading: false,
      summarizeData: {},
      roomIdOptions: [], // 存储所有群聊 ID 选项
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.obtainDataSource();
    this.fetchAllEmployees();
    this.getAllUsers();
    this.getlist();
    this.getRoomIdOptions(); // 初始化时获取群聊 ID 列表
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
    // 可添加的员工（所有员工中排除已有指标记录的）
    availableAddUsers() {
      return this.allEmployees
        .filter(emp => !this.tradeUserIds.includes(emp.id))
        .map(emp => ({
          id: emp.id,
          label: (emp.name || '') + (emp.shop_name ? ' - ' + emp.shop_name : ''),
          shop_id: emp.main_shop_id || 0,
        }));
    },
    userColumns() {
      if (!this.basicListconfig.data || this.basicListconfig.data.length === 0) {
        return [];
      }
      const userMap = new Map();
      this.basicListconfig.data.forEach(item => {
        if (!userMap.has(item.user_id)) {
          userMap.set(item.user_id, {
            id: item.id,
            user_id: item.user_id,
            shop_id: item.shop_id,
            name: item.name,
            username: item.username,
            turnover_trade: item.turnover_trade,
            turnover_ratio: item.turnover_ratio,
            order_trade: item.order_trade,
            order_ratio: item.order_ratio,
            profit_trade: item.profit_trade,
            profit_ratio: item.profit_ratio,
            sales_trade: item.sales_trade,
            sales_ratio: item.sales_ratio,
            stock_check_trade: item.stock_check_trade,
            stock_check_ratio: item.stock_check_ratio,
            room_id: item.room_id
          });
        }
      });
      return Array.from(userMap.values());
    },
  },
  methods: {
    // 获取群聊 ID 列表
    getRoomIdOptions() {
      const params = {
        comp_id: this.compId,
        page: 1,
        limit: 1000  // 获取所有数据
      };
      if (this.basicListconfig.searchParameters.shop_id) {
        params.shop_id = this.basicListconfig.searchParameters.shop_id;
      }

      getRoomIdList(params).then((res) => {
          console.log('群聊 ID 接口返回:', res);
          if (res.code == 1 || res.code == 200) {
            // 从 list 中提取所有不同的 room_id
            const roomIds = new Set();
            const roomMap = new Map();
            const listData = (res.data && res.data.list) || res.data || [];
            console.log('list 数据:', listData);
            listData.forEach(item => {
              if (item.room_id) {
                roomIds.add(item.room_id);
                // 保存 room_id 对应的 room_name
                roomMap.set(item.room_id, item.room_name);
              }
            });

            this.roomIdOptions = Array.from(roomIds).map(roomId => ({
            label: `${roomMap.get(roomId) || ''} ${roomId}`,
            value: roomId
          }));
            console.log('群聊 ID 选项:', this.roomIdOptions);
          }
        });
    },
    handleTradeChange(row, userId) {
      row[userId + '_trade'] = Number(row[userId + '_trade']) || 0;
    },
    handleRatioChange(row, userId) {
      row[userId + '_ratio'] = Number(row[userId + '_ratio']) || 0;
    },
    editUserMetric(userId) {
      const userData = this.userColumns.find(item => item.user_id == userId);
      if (!userData) {
        this.$message.error('未找到用户数据');
        return;
      }

      const ratioSum =
        Number(userData.turnover_ratio || 0) +
        Number(userData.order_ratio || 0) +
        Number(userData.profit_ratio || 0) +
        Number(userData.sales_ratio || 0) +
        Number(userData.stock_check_ratio || 0);

      if (ratioSum > 100) {
        this.$message.error('该用户的所有占比总和不能超过 100%，当前总和：' + ratioSum + '%');
        return;
      }

      const ratioFields = [
        { name: '销售额占比', value: userData.turnover_ratio },
        { name: '订单数占比', value: userData.order_ratio },
        { name: '毛利占比', value: userData.profit_ratio },
        { name: '动销数占比', value: userData.sales_ratio },
        { name: '盘库数占比', value: userData.stock_check_ratio },
      ];

      for (let field of ratioFields) {
        if (field.value && (Number(field.value) < 0 || Number(field.value) > 100)) {
          this.$message.error(field.name + '不能超过 100% 且不能小于 0');
          return;
        }
      }

      // 先查询是否已有该用户的指标数据
      getPersonalMetricList({
        comp_id: this.compId,
        user_id: userId
      }).then((res) => {
        if (res.code == 1 && res.data && res.data.length > 0) {
          // 已有数据，执行更新
          const existingData = res.data[0];
          userData.id = existingData.id;

          personalMetricUp({
            comp_id: this.compId,
            user_id: userId,
            shop_id: userData.shop_id || this.basicListconfig.searchParameters.shop_id || 0,
            turnover_trade: userData.turnover_trade,
            turnover_ratio: userData.turnover_ratio,
            order_trade: userData.order_trade,
            order_ratio: userData.order_ratio,
            profit_trade: userData.profit_trade,
            profit_ratio: userData.profit_ratio,
            sales_trade: userData.sales_trade,
            sales_ratio: userData.sales_ratio,
            stock_check_trade: Number(userData.stock_check_trade) || 0,
            stock_check_ratio: userData.stock_check_ratio,
            room_id: userData.room_id,
            id: userData.id
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.getlist();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          // 无数据，直接调用更新接口（后端会自动创建）
          personalMetricUp({
            comp_id: this.compId,
            user_id: userId,
            shop_id: userData.shop_id || this.basicListconfig.searchParameters.shop_id || 0,
            turnover_trade: userData.turnover_trade,
            turnover_ratio: userData.turnover_ratio,
            order_trade: userData.order_trade,
            order_ratio: userData.order_ratio,
            profit_trade: userData.profit_trade,
            profit_ratio: userData.profit_ratio,
            sales_trade: userData.sales_trade,
            sales_ratio: userData.sales_ratio,
            stock_check_trade: Number(userData.stock_check_trade) || 0,
            stock_check_ratio: userData.stock_check_ratio,
            room_id: userData.room_id
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.getlist();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    editMetric(row) {
      let hasError = false;
      const updatePromises = [];

      this.userColumns.forEach(user => {
        if (hasError) return;

        const userData = this.basicListconfig.data.find(item => item.user_id === user.user_id);
        if (userData) {
          const ratioSum =
            Number(userData.turnover_ratio || 0) +
            Number(userData.order_ratio || 0) +
            Number(userData.profit_ratio || 0) +
            Number(userData.sales_ratio || 0) +
            Number(userData.stock_check_ratio || 0) +
            Number(userData.room_ratio || 0);

          if (ratioSum > 100) {
            this.$message.error(user.name + '的所有占比总和不能超过 100%，当前总和：' + ratioSum + '%');
            hasError = true;
            return;
          }

          const ratioFields = [
            { name: '销售额占比', value: userData.turnover_ratio },
            { name: '订单数占比', value: userData.order_ratio },
            { name: '毛利占比', value: userData.profit_ratio },
            { name: '动销数占比', value: userData.sales_ratio },
            { name: '盘库数占比', value: userData.stock_check_ratio }
          ];

          for (let field of ratioFields) {
            if (field.value && (Number(field.value) < 0 || Number(field.value) > 100)) {
              this.$message.error(user.name + '的' + field.name + '不能超过 100% 且不能小于 0');
              hasError = true;
              return;
            }
          }

          const apiCall = personalMetricUp({
              comp_id: this.compId,
              user_id: user.user_id,
              turnover_trade: userData.turnover_trade,
              turnover_ratio: userData.turnover_ratio,
              order_trade: userData.order_trade,
              order_ratio: userData.order_ratio,
              profit_trade: userData.profit_trade,
              profit_ratio: userData.profit_ratio,
              sales_trade: userData.sales_trade,
              sales_ratio: userData.sales_ratio,
              stock_check_trade: Number(userData.stock_check_trade) || 0,
              stock_check_ratio: userData.stock_check_ratio,
              room_id: userData.room_id,
              id: userData.id
            });

          updatePromises.push(
            apiCall.then((res) => {
              if (res.code == 1) {
                this.$message.success(user.name + "操作成功");
              } else {
                this.$message.error(res.data.msg);
              }
            })
          );
        }
      });

      if (!hasError && updatePromises.length > 0) {
        Promise.all(updatePromises).then(() => {
          this.getlist();
        });
      }
    },

   sortChange(data) {
     this.basicListconfig.searchParameters.page = 1;
     this.basicListconfig.searchParameters.order_column = data.prop;
     this.basicListconfig.searchParameters.order_up =data.order;
     this.getlist();
   },
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
          if (key == "time") {
            this.basicListconfig.searchParameters["begin_time"] = data[key]
              ? data[key][0]
              : null;
            this.basicListconfig.searchParameters["end_time"] = data[key]
              ? data[key][1]
              : null;
          }
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    handleCurrentChange(val) {
      this.searchEvent(this.searchForm, val, "");
    },
    handleSizeChange(val) {
      this.searchEvent(this.searchForm, "", val);
    },
    getlist() {
      this.basicListconfig.loading = true;

      // 获取员工列表作为数据源（带筛选条件）
      const params = {
        comp_id: this.compId,
        page: this.basicListconfig.page || 1,
        limit: this.basicListconfig.searchParameters.limit || 20
      };

      console.log('getlist searchParameters:', this.basicListconfig.searchParameters);

      if (this.basicListconfig.searchParameters.shop_id) {
        params.shop_id = this.basicListconfig.searchParameters.shop_id;
      }

      if (this.basicListconfig.searchParameters.user_id) {
        params.user_id = this.basicListconfig.searchParameters.user_id;
      }

      console.log('getlist 请求参数:', params);

      getPersonalMetricList(params).then((res) => {
        console.log('getlist 返回数据:', res);
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.total = res.total || 0;
          // 将员工列表转换为指标数据格式
          this.basicListconfig.data = res.data || [];
          console.log('设置后的数据:', this.basicListconfig.data);

          // 获取群聊 ID 选项
          this.getRoomIdOptions();
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    obtainDataSource() {
      // 获取门店列表
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );


    },
    // 获取有指标记录的员工列表（用于员工筛选下拉）
    getAllUsers() {
      return new Promise((resolve) => {
        console.log('开始获取有指标记录的员工列表, comp_id:', this.compId);
        getPersonalMetricList({ comp_id: this.compId, page: 1, limit: 9999 }).then((res) => {
          console.log('指标员工列表返回:', res);
          if (res.code == 1) {
            // 从指标数据中提取唯一员工
            const userMap = new Map();
            const userIds = [];
            (res.data || []).forEach(item => {
              if (!userMap.has(item.user_id)) {
                userMap.set(item.user_id, {
                  id: item.user_id,
                  name: item.name,
                  shop_id: item.shop_id,
                });
                userIds.push(parseInt(item.user_id));
              }
            });
            this.allUsers = Array.from(userMap.values());
            this.tradeUserIds = userIds;
            console.log('有指标的员工数据:', this.allUsers);
            // 初始化员工下拉选项
            this.basicListconfig.search.map((item) => {
              if (item.key == "user_id") {
                item.options = this.allUsers.map((user) => {
                  return {
                    label: user.name,
                    value: user.id,
                  };
                });
                console.log('员工下拉选项:', item.options);
              }
              return item;
            });
          }
          resolve();
        });
      });
    },
    // 获取所有员工（用于添加员工下拉）
    fetchAllEmployees() {
      return new Promise((resolve) => {
        userGetlist({ status: 0, comp_id: this.compId }).then((res) => {
          if (res.code == 1) {
            this.allEmployees = res.data || [];
            console.log('所有员工数据:', this.allEmployees);
          }
          resolve();
        });
      });
    },
    // 打开添加员工弹窗
    openAddUserDialog() {
      this.selectedAddUser = [];
      this.addUserDialogVisible = true;
    },
    // 确认添加员工参与指标（支持多选）
    confirmAddUser() {
      const selectedUsers = this.availableAddUsers.filter(u => this.selectedAddUser.includes(u.id));
      if (!selectedUsers || selectedUsers.length === 0) {
        this.$message.error('请选择员工');
        return;
      }

      this.addUserLoading = true;
      const promises = selectedUsers.map(user => {
        return personalMetricUp({
          comp_id: this.compId,
          user_id: user.id,
          shop_id: user.shop_id,
          turnover_trade: 0,
          turnover_ratio: 0,
          order_trade: 0,
          order_ratio: 0,
          profit_trade: 0,
          profit_ratio: 0,
          sales_trade: 0,
          sales_ratio: 0,
          stock_check_trade: 0,
          stock_check_ratio: 0,
          room_id: '',
        });
      });

      Promise.all(promises).then((results) => {
        this.addUserLoading = false;
        const allSuccess = results.every(r => r.code == 1);
        if (allSuccess) {
          this.$message.success(`成功添加 ${selectedUsers.length} 名员工`);
          this.addUserDialogVisible = false;
          this.getlist();
          this.getAllUsers();
        } else {
          this.$message.error('部分添加失败，请重试');
        }
      }).catch(() => {
        this.addUserLoading = false;
        this.$message.error('添加失败');
      });
    },
    // 处理门店变化，联动筛选员工
    handleShopChange(shopId) {
      // 清空员工选择
      this.basicListconfig.searchParameters.user_id = '';

      // 根据门店筛选员工选项（按指标数据中的 shop_id 筛选）
      const userSelect = this.basicListconfig.search.find(item => item.key === "user_id");
      if (userSelect) {
        if (!shopId) {
          // 如果没有选择门店，显示所有有指标的员工
          userSelect.options = this.allUsers.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });
        } else {
          // 根据门店筛选员工（按指标表中的 shop_id）
          const filteredUsers = this.allUsers.filter(user => {
            return user.shop_id == shopId;
          });
          userSelect.options = filteredUsers.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });
        }
      }

      // 重新获取列表数据
      this.getlist();
      // 重新获取群聊 ID 列表
      this.getRoomIdOptions();
    },
  },
};
</script>

<style  scoped>
.search_total {
  display: flex;
  line-height: 32px;
}
.search_total p {
  font-size: 16px;
  padding: 0 10px;
  font-weight: bold;
  color: #ffa100;
}
.search_total p span {
  color: rgba(0, 0, 0, 0.6);
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/personalMetric/index.vue